/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsEditNewsResponse } from "./NewsEditNewsResponse";

export type NewsEditNewsResponseApiRespoonse = {
  data?: NewsEditNewsResponse;
  status?: NewsEditNewsResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace NewsEditNewsResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
